<template>
  <div class="d-flex flex-wrap ga-2 mt-2">
    <v-btn size="small" color="primary" variant="outlined" :disabled="!boardId" @click="$emit('open-board')">
      <v-icon start size="16">mdi-view-column</v-icon>
      {{ $t("ncrm.leads.details.actions.openBoard") }}
    </v-btn>
    <v-btn size="small" color="primary" variant="outlined" :disabled="!sourceRoute" @click="$emit('open-source')">
      <v-icon start size="16">mdi-open-in-new</v-icon>
      {{ $t("ncrm.leads.details.actions.openSource") }}
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "NcrmLeadContextActions",
  emits: ["open-board", "open-source"],
  props: {
    boardId: {
      type: [String, Number],
      default: null,
    },
    sourceRoute: {
      type: [String, Object],
      default: null,
    },
  },
};
</script>
